import * as React from "react";

import { cn } from "../utils";

export interface RequiredMarkProps {
  /** When falsy (false / null / undefined) nothing is rendered. */
  required?: boolean | null;
  /** Extra classes appended to the default styling. */
  className?: string;
}

/**
 * RequiredMark
 *
 * V&A Waterfront Design System - Required-field indicator
 *
 * The single source of truth for the `*` shown next to a required field's
 * label or legend. Use it in every form-field component so the indicator stays
 * visually and behaviourally consistent, and so future field types inherit it.
 *
 * @example
 * <label>
 *   {label}
 *   <RequiredMark required={required} />
 * </label>
 */
const RequiredMark = ({ required, className }: RequiredMarkProps) => {
  if (!required) return null;
  return (
    <span className={cn("text-text-feedback-error ml-1", className)}>*</span>
  );
};

RequiredMark.displayName = "RequiredMark";

export { RequiredMark };
